import React from "react";
import "../Invitation/styles.css";
export default function InviteSuccess() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>邀请成功</h1>
      <p>您已成功接受邀请，欢迎加入我们的大家庭！</p>
      <button className="submit-btn">下载“伴知宠”</button>
    </div>
  );
}
